import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appEzRight]',
})
export class EzRightDirective {
  templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}
